import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=7e48a4bb"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e48a4bb')) {
      api.createRecord('7e48a4bb', component.options)
    } else {
      api.reload('7e48a4bb', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=7e48a4bb", function () {
      api.rerender('7e48a4bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/investment/edit.vue"
export default component.exports